import { BarceloComponent } from "components-utils";

const FormsComponents = {
  loggedUpdateForm: BarceloComponent({
    selector: ".c-logged-update-form",
    path: "barcelo/forms/logged-update-form/js/logged-update-form",
  }),

  dataCollectDestinationForm: BarceloComponent({
    selector: ".c-data-collect-destination-form-dl-id",
    path: "barcelo/forms/data-collect-destination-form/js/data-collect-destination-form",
  }),

  serviceContactForm: BarceloComponent({
    selector: ".service-contact-form-dl-id",
    path: "barcelo/forms/service-contact-form/js/c-service-contact-form",
  }),

  experiencesForm: BarceloComponent({
    selector: ".c-experiences-form",
    path: "barcelo/forms/experiences-form/js/experiences-form",
  }),

  deleteMyBarceloForm: BarceloComponent({
    selector: ".c-delete-mybarcelo-form",
    path: "barcelo/forms/delete-my-barcelo-form/js/c-delete-my-barcelo-form",
  }),

  newsletterForm: BarceloComponent({
    selector: ".c-newsletter-form",
    path: "barcelo/forms/newsletter-form/js/c-newsletter-form",
  }),
};

export default FormsComponents;
